import api from './api';

export const authService = {
  login: async (email, password) => {
    const response = await api.post('/auth/login.php', { email, password });
    return response.data;
  },

  register: async (name, email, password, role) => {
    const response = await api.post('/auth/register.php', { name, email, password, role });
    return response.data;
  },

  verifyOTP: async (email, otp) => {
    const response = await api.post('/auth/verify-otp.php', { email, otp });
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
  },

  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('access_token');
  },
};
